module.exports = __webpack_public_path__ + "img/icon-file-format.87ade8ae.svg";